import SanityBlockContent from '@sanity/block-content-to-react';
import { SocialShare } from 'components/shared/SocialShare';
import moment from 'moment';
import Head from 'next/head';
import Image from 'next/image';
import Link from 'next/link';
import styled from 'styled-components';

import { SuccessRoundButton } from '@/design-system/buttons';

import { Section } from '../shared/Section';
import { CommentSection } from './CommentSection';
import { RelatedArticles } from './RelatedArticles';

const StyledArticleReader = styled.div`
  padding: 4em 1em;
  max-width: 900px;
  margin: auto;

  .title {
    font-size: 3rem;
    font-weight: 600;
  }

  .article-meta {
    span:not(:last-child) {
      padding-right: 0.5em;
      margin-right: 0.5em;
      border-right: 1px solid ${(props) => props.theme.primaryLink};
    }

    .read-duration {
      color: ${(props) => props.theme.primaryLink};
    }

    margin-bottom: 2em;
  }

  .social-share {
    width: fit-content;

    &--bottom {
      display: flex;
      align-items: center;

      span {
        margin-right: 2em;
        font-size: 1.8rem;
        font-weight: 600;
      }
    }
  }

  .cover-image-container {
    display: flex;
    width: 100%;
    height: 200px;
    overflow: hidden;
    border-radius: 15px;
    position: relative;

    @media screen and (min-width: 768px) {
      height: 300px;
    }

    .img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      position: absolute;
    }
  }

  .ad-block {
    overflow: hidden;
    background-color: ${(props) => props.theme.primaryLink};
    background: ${({ theme }) =>
      `linear-gradient(270deg, ${theme.primaryLink} 2.58%, ${theme.headerBackground} 119.34%)`};
    border-radius: 15px;
    margin-bottom: 3.5em;
    padding: 2em;

    &.last {
      margin-top: 5em;
    }

    .title,
    .description {
      color: white;
    }

    .description {
      max-width: 500px;
    }

    .title {
      padding-top: 0!;
      line-height: 1;
    }

    .ctas {
      margin-top: 2em;

      .cta {
        background-color: white;
        color: #111;
        text-transform: none;
      }
    }
  }

  .article-body {
    p {
      font-size: 1.65rem;
    }

    figure {
      width: 100%;
      display: grid;
      justify-content: center;
      margin: 2em 0;
    }

    .img {
      width: 100%;
    }
  }
`;

export const ArticleReader = ({ auth, article }) => {
  return (
    article && (
      <StyledArticleReader>
        <Head>
          <title>{`Brytahub Blog - Article Title goes here`}</title>
        </Head>

        <Section>
          <h1 className="title">{article.title}</h1>

          <div className="article-meta">
            <span>By {article.author?.name}</span>
            <span>{moment(article._updatedAt).toDate().toDateString()}</span>
            <span className="read-duration">3 minutes read</span>
          </div>

          <div className="social-share">
            <SocialShare title={article.title} />
          </div>
        </Section>

        <Section className="cover-image-container">
          <Image src={article.coverImage?.asset?.url} layout="fill" className="img" alt="" />
        </Section>

        <Section className="article-body">
          <SanityBlockContent
            blocks={article.bodyRaw}
            className="block-content"
            projectId={process.env.NEXT_PUBLIC_SANITY_PROJECT_ID}
            dataset={process.env.NEXT_PUBLIC_SANITY_DATASET}
          />
        </Section>

        <Section className="ad-block">
          <h3 className="title">Learn from industry experts</h3>
          <p className="description">
            We partner with experts across many fields to provide indepth practical training for our
            students.
          </p>
          <div className="ctas">
            <Link href="/">
              <a>
                <SuccessRoundButton className="cta">Browse courses</SuccessRoundButton>
              </a>
            </Link>
          </div>
        </Section>

        <Section className="social-share social-share--bottom">
          <span>Share on</span> <SocialShare title={'Title of the post'} />
        </Section>

        <Section>
          <RelatedArticles article={article} />
        </Section>

        <Section>
          <CommentSection articleId={article._id} auth={auth} />
        </Section>

        <Section className="ad-block last">
          <h2 className="title">Train On Brytahub</h2>
          <p className="description">
            We partner with experts across many fields to provide indepth practical training for our
            students. Sounds interesting? &nbsp;
            <b>Show us what you do.</b>
          </p>
          <div className="ctas">
            <Link href="/">
              <a>
                <SuccessRoundButton className="cta">Send us a mail</SuccessRoundButton>
              </a>
            </Link>
          </div>
        </Section>
      </StyledArticleReader>
    )
  );
};
